// Per-route JSON-LD injector.
//
// Sibling to useDocumentMeta (which owns title / description / canonical /
// hreflang). This hook injects a <script type="application/ld+json"> into
// <head> describing the current page (e.g. Product + AggregateOffer +
// BreadcrumbList for a destination) and REMOVES it on route change / unmount
// so we never leave a stale or duplicate graph behind. Googlebot renders the
// React app (confirmed via GSC), so client-injected structured data is read.
//
// NOTE: per-route Open Graph for social unfurling is intentionally NOT done
// here — social crawlers (Facebook, X, iMessage, LinkedIn) don't execute JS,
// so client-injected OG would only ever reach Googlebot. Fixing link
// previews properly needs prerendered HTML, which the project has ruled out.

import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export function useStructuredData(jsonLd: object | null) {
  const location = useLocation()

  useEffect(() => {
    if (!jsonLd) return
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.setAttribute('data-jsonld', 'route')
    script.text = JSON.stringify(jsonLd)
    document.head.appendChild(script)
    return () => {
      script.remove()
    }
  }, [jsonLd, location.pathname])
}
